import { api } from './BaseService'

export const getColors = async () => {
    const res= await api.get(`/colors`)
    return res
}
export const getColorById = async (id) => {
    return await api.get(`/colors/${id}`)
}

export const createColor = async (data) => {
    return await api.post(`/colors`, data)
}
export const updateColor = async (data) => {
    return await api.put(`/colors/${data?.id}`, data)
}
export const deleteColor = async (id) => {
    return await api.delete(`/colors/${id}`)
}
